export enum ClaimPaymentMethod {
    CHECK = 'ACH',
    DIRECT_DEPOSIT = 'Direct Deposit',
}
